export default __webpack_public_path__ + "static/media/MishalJoeAlias.051ad42c.jpg";